import { BaseAPI } from './BaseAPI.js'
import { Call, CallEvents } from '../types/index.js'

export default class CallsAPI extends BaseAPI<Call, CallEvents> {
  override get resource(): string {
    return '/calls'
  }

  override get hasEvents(): boolean {
    return true
  }

  public async setOutcomes(
    id: number,
    {
      nextLead,
      isHuman,
      isVoicemail,
      isSale,
      isDoNotDial,
      name,
    }: {
      nextLead?: boolean
      isHuman?: boolean
      isVoicemail?: boolean
      isSale?: boolean
      isDoNotDial?: boolean
      name?: string
    },
  ): Promise<Call> {
    const result = await this._client.patch(`calls/${id}/outcomes`, {
      data: {
        type: 'callOutcomes',
        attributes: {
          nextLead,
          isHuman,
          isVoicemail,
          isSale,
          isDoNotDial,
          name,
        },
      },
    })
    return result.data
  }

  public async getRecording(id: number) {
    const { data } = await this._client.get(`calls/${id}.ogg`, {
      headers: {
        'Content-Type': 'audio/ogg',
      },
      responseType: 'arraybuffer',
    })
    return new Blob([data], {
      type: 'audio/ogg',
    })
  }
}
